import Section from "@features/Course/parts/course/Content/parts/Section";
import Accordion from "@components/UI/Accordion";
import styles from "./style.module.sass";
import AccordionTime from "@features/Course/parts/course/Content/parts/AccordionTime";
import { SectionDto } from "@generated/models/SectionDto";

type ContentAccordionProps = {
	section: SectionDto;
};

const ContentAccordion = ({ section }: ContentAccordionProps) => {
	return (
		<Accordion
			titleChildren={
				<div className={styles.accordionTitleWrapper}>
					<h4 className={styles.accordionTitle}>{section.title}</h4>
					<AccordionTime section={section} />
				</div>
			}
			variant="filled"
		>
			<Section items={section.lectures} />
		</Accordion>
	);
};

export default ContentAccordion;
